import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/constants";

export default function StickyWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={WHATSAPP_LINK()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل واتساب"
      data-testid="whatsapp-sticky-button"
      className={`fixed bottom-20 start-5 md:bottom-6 md:start-6 z-50 flex items-center gap-2 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="hidden md:inline-block bg-white text-brand-green font-heading font-extrabold text-sm px-4 py-2 rounded-full shadow-lg border border-brand-gold/20">
        تواصل معنا واتساب
      </span>
      <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1fb858] text-white flex items-center justify-center shadow-[0_10px_25px_-5px_rgba(37,211,102,0.5)] wa-pulse transition-transform hover:scale-110">
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8" />
      </span>
    </a>
  );
}
